import { Col, Layout, Row } from 'antd';
import styled from 'styled-components';

import _ from 'lodash';
import { useEffect, useState } from 'react';
import { API_URI, APP_IMG, SOCIALS } from 'src/constants';

const Footer = Layout.Footer;
const FooterComponent = () => {
  const [contact, setContact] = useState({});
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_URI}/api/footer`, {
          method: 'GET',
          headers: {
            'Content-Type': 'text/plain' // Solved issues call OPTIONS
          }
        });
        const data = await res.json();
        setContact(data);
      } catch (err) {
        console.error('Footer', err);
      }
    })();
  }, []);
  return (
    <>
      <FooterWrapper>
        <Row className='footer-body'>
          <Col xs={24} md={12}>
            <a className='logo-footer' href='https://www.komchadluek.net/' rel='noopener noreferrer' target='_blank' alt='komchadluek'>
              <img src={`${APP_IMG}/images/logo-web/komchadluek-logo-04.webp?x-image-process=style/lg-webp`} alt='logo-footer' />
            </a>
            <ul>
              {!_.isEmpty(contact) && (
                <li
                  className='footer-contact'
                  dangerouslySetInnerHTML={{
                    __html: contact?.data
                  }}
                />
              )}
            </ul>

            <span className='truehit' id='truehits_div' />
          </Col>
          <Col xs={24} md={{ span: 8, offset: 4 }}>
            <GradientBorder>
              <div className='--bg'>
                <p>SUBSCRIBER</p>
              </div>
            </GradientBorder>
            <div className='socials'>
              {SOCIALS.map((item, i) => (
                <div key={i} className='flex'>
                  <span>
                    <a href={item.link} className='socials-link'>
                      {item.icon}
                      <span>{item.name}</span>
                    </a>
                  </span>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </FooterWrapper>
    </>
  );
};

const FooterWrapper = styled(Footer)`
  position: relative;
  display: block;
  width: 100%;
  background: rgb(149,14,14);
  background: linear-gradient(90deg, rgba(0,0,0,1) 0%, rgb(149,14,14) 100%);
  padding: 24px 24px;
  z-index: 2;
  .footer-body {
    width: 100%;
    max-width: 1300px;
    width: 100%;
    height: auto;
    margin: 0 auto;
    color: #fff;
    .footer-contact {
      p {
        font-size: 16px;
        text-align: start;
      }
    }
  }
  .logo-footer {
    img {
      margin-bottom: 20px;
      width: 150px;
    }
  }
  ul {
    padding-left: 0;
    list-style: none;
    @media (max-width: 480px) {
      display: flex;
      /* justify-content: center;
      align-items: center; */
      flex-direction: column;
    }
  }
  p {
    text-align: center;
    font-size: 26px;
    font-weight: 200;
  }

  .socials {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding-top: 10px;
    .flex {
      display: flex;
      align-items: center;
      padding-bottom: 5px;
      svg {
        width: 20px;
        height: auto;
      }
      span {
        font-size: 18px;
        padding-left: 10px;
        @media (min-width: 768px) {
          font-size: 15px;
        }
        @media (max-width: 480px) {
          font-size: 12px;
        }
      }
    }
    .socials-link {
      text-decoration: none;
      color: white;
      align-items: center;
      display: flex;
    }
  }
`;

const GradientBorder = styled.div`
  display: block;
  width: 100%;
  max-width: 1300px;
  background: linear-gradient(0deg, rgba(181,181,181,1) 0%, rgba(82,82,82,1) 12%, rgba(255,255,255,1) 25%, rgba(206,206,206,1) 63%, rgba(98,98,98,1) 83%, rgba(163,163,163,1) 100%); 
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border-radius: 2px;
  padding: 4px;
  margin: 10px auto;

  .--bg {
    background:#A20202; //*
    border-radius: 2px;
  }
  @media (max-width: 475px) {
    margin: 40px auto 10px auto;
  }
`;

export default FooterComponent;
